module.exports = __webpack_public_path__ + "img/offline.ab06b772.svg";